import { render, staticRenderFns } from "./Telehealth.vue?vue&type=template&id=86e400a4&"
import script from "./Telehealth.vue?vue&type=script&lang=js&"
export * from "./Telehealth.vue?vue&type=script&lang=js&"
import style0 from "./Telehealth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports